import React, { useState, useCallback, useRef, useEffect } from 'react';
import { classNames } from '../../helpers/classnames.js';
import { renderChildren } from './render-children.js';

var Breadcrumbs = function (_a) {
    var children = _a.children, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, className = _a.className;
    var _c = useState(collapsed), isCollapsed = _c[0], setCollapsed = _c[1];
    var handleClickAway = useCallback(function () {
        collapsed && setCollapsed(true);
    }, [collapsed, setCollapsed]);
    var handleClickDots = function () {
        setCollapsed(false);
    };
    var navRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (navRef.current && !document.contains.call(navRef.current, event.target)) {
                handleClickAway();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [navRef, handleClickAway]);
    return (React.createElement("nav", { "data-testid": "Breadcrumbs", ref: navRef, className: classNames(className, 'dsb-breadcrumbs') },
        React.createElement("ul", { className: "dsb-breadcrumbs__list" }, renderChildren(children, isCollapsed, handleClickDots))));
};

export { Breadcrumbs };
